import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"
import Img from "gatsby-image/withIEPolyfill"
import Observer from "react-intersection-observer"
import { Player } from "@lottiefiles/react-lottie-player"
import { isMobile } from "react-device-detect"

import { TYPE, COLORS } from "../../../../theme/styles/globals"
import { MEDIA_TYPE, DECORATIONS, RATIO } from "../../globals"
import AspectRatio from "../../../atomic/molecules/AspectRatio"
import HorizontalPlayIndicator from "../../../atomic/organisms/HorizontalPlayIndicator"

import Browser from "./decorations/Browser"
import SocialThreeByFour from "./decorations/SocialThreeByFour"
import SocialNineBySixteen from "./decorations/SocialNineBySixteen"
import SocialOneByOne from "./decorations/SocialOneByOne"

export default class ContentfulBlockMedia extends React.Component {

  player = null

  state = {
    playing: false,
    inView: false,
    animationData: null,
  }

  onInView = inView => {
    if (inView) {
      this.setState({ inView: true }, () => {
        if (this.player && this.player.play) this.player.play()
      })
    } else {
      this.setState({ inView: false }, () => {
        if (this.player && this.player.pause) this.player.pause()
      })
    }
  }

  renderVideo() {
    const {
      fixedWidth,
      align,
      ratio,
      placeholder,
      media,
      label,
      width,
      height,
      maxHeight,
      mode,
      playable,
      contentful_id,
      decoration,
      type,
      text
    } = this.props

    let DOM = ``

    if (playable) DOM = this.playableVideo()

    if (!playable && !decoration) DOM = this.inlineVideo()

    if (!playable && decoration === DECORATIONS.SOCIAL_3_4) DOM = <SocialThreeByFour mode={mode} video={media.file.url} uid={contentful_id} label={label} text={text} />

    if (!playable && decoration === DECORATIONS.SOCIAL_9_16) DOM = <SocialNineBySixteen mode={mode} video={media.file.url} uid={contentful_id} label={label} text={text} />

    if (!playable && decoration === DECORATIONS.SOCIAL_1_1) DOM = <SocialOneByOne mode={mode} video={media.file.url} uid={contentful_id} label={label} text={text} />

    if (!playable && decoration === DECORATIONS.BROWSER) DOM = <Browser url={media.file.url} uid={contentful_id} mode={mode} label={label} text={text} />

    return DOM

  }

  inlineVideo() {
    const {
      align,
      ratio,
      placeholder,
      media,
      label,
      width,
      height,
      maxHeight,
      playable,
      contentful_id,
      decoration,
    } = this.props

    return (
      <AspectRatio align={align} ratio={ratio} max={maxHeight}>
        <InView
          tag="div"
          onChange={inView => 
            inView
              ? document.getElementById(`video-${contentful_id}`).play()
              : document.getElementById(`video-${contentful_id}`).pause()
          }
          rootMargin={isMobile ? "100px 0px" : "0px -600px"}
        >
          <VideoWrap>
            <video
              poster={ (placeholder ? placeholder.file.url : "") }
              id={`video-${contentful_id}`}
              // autoPlay={isMobile ? "autoPlay" : false}
              autoPlay
              loop
              muted
              playsInline
            >
              <source src={media.file.url} type="video/mp4" />
            </video>
          </VideoWrap>
        </InView>
      </AspectRatio>
    )
  }

  playableVideo() {
    const {
      align,
      ratio,
      placeholder,
      media,
      label,
      width,
      height,
      maxHeight,
      playable,
      contentful_id,
      decoration,
      mode
    } = this.props

    const color = mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`

    return (
      <AspectRatio align={align} ratio={ratio} max={maxHeight}>
        <InView tag="div" onChange={this.onInView} rootMargin={"0px 600px"}>
          {label && 
            <LabelWrap>
              <Label color={color}>{label}</Label>
            </LabelWrap>
          }
          <VideoWrap className={`block-media block-media-video`}>
            {playable && !this.state.playing && (
              <Indicator
                onClick={() => {
                  const video = document.getElementById(
                    `video-${contentful_id}`
                  )
                  video.muted = false
                  video.pause()
                  video.loop = false
                  video.currentTime = 0
                  video.play()
                  this.setState({ playing: true })
                }}
              >
                <HorizontalPlayIndicator />
              </Indicator>
            )}
            <video
              poster={ (placeholder ? placeholder.file.url : "") }
              id={`video-${contentful_id}`}
              onEnded={() => {
                this.setState({ playing: false })
                const video = document.getElementById(`video-${contentful_id}`)
                video.muted = true
                video.pause()
                video.loop = true
                video.currentTime = 0
                video.play()
              }}
              onClick={() => {
                this.setState({ playing: false })
                const video = document.getElementById(`video-${contentful_id}`)
                video.muted = true
                video.pause()
                video.loop = true
                video.play()
              }}
              autoPlay={isMobile ? "autoPlay" : false}
              loop
              muted
              playsInline
            >
              <source src={media.file.url} type="video/mp4" />
            </video>
          </VideoWrap>
        </InView>
      </AspectRatio>
    )
  }

  renderLottie() {
    const {
      align,
      ratio,
      placeholder,
      media,
      label,
      width,
      height,
      maxHeight,
    } = this.props

    return (
      <React.Fragment>
        <AspectRatio ratio={ratio} max={maxHeight} align={align}>
          <InView tag="div" onChange={this.onInView} rootMargin={"0px 400px"}>
            <LottieWrap className={`block-media block-media-lottie`}>
              <Player
                ref={el => (this.player = el)}
                autoplay={false}
                loop={true}
                mode="normal"
                src={`https:${media.file.url}`}
                style={{ width: "100%", height: "100%" }}
              />
            </LottieWrap>
          </InView>
        </AspectRatio>
      </React.Fragment>
    )
  }

  renderImage() {
    const {
      align,
      ratio,
      placeholder,
      media,
      label,
      width,
      height,
      maxHeight,
    } = this.props

    return (
      <AspectRatio ratio={ratio} max={maxHeight} align={align}>
        <Container align={align} className={`block-media block-media-image`}>
          <Image fluid={media.fluid} align={align} />
        </Container>
      </AspectRatio>
    )
  }

  render() {
    const { type } = this.props

    return (
      <React.Fragment>
        {type === MEDIA_TYPE.IMAGE ? this.renderImage() : null}
        {type === MEDIA_TYPE.LOTTIE ? this.renderLottie() : null}
        {type === MEDIA_TYPE.VIDEO ? this.renderVideo() : null}
      </React.Fragment>
    )
  }
}
const Container = styled.div`
  position: relative;
  padding-left: 14px;
  padding-right: 14px;
  width: 100%;

  ${props => (props.align === "MIDDLE" ? "padding-bottom:30px;" : "")}

  ${up("md")} {
    padding-left: 0px;
    padding-right: 0px;
    padding-bottom: 0px;
    width: 100%;
    height: 100%;
  }
`

const InView = styled(Observer)`
  width: 100%;
  height: 100%;
  position: relative;
`

const Image = styled(Img)`
  width: 100%;

  ${up("md")} {
    width: 100%;
    height: 100%;
  }
`

const VideoWrap = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  padding-left: 14px;
  padding-right: 14px;
  overflow: hidden;
  margin-bottom: 30px;

  video {
    width: 100%;
    cursor: pointer;
  }

  ${up("md")} {
    width: 100%;
    height: 100%;
    padding-left: 0px;
    padding-right: 0px;
    margin-bottom: 0px;

    video {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
`



const LottieWrap = styled.div`
  width: 100%;

  ${up("md")} {
    width: 100%;
    height: 100%;
  }
`

const Indicator = styled.div`
  width: calc(100% - 28px);
  height: calc(100% - 4px);
  position: absolute;
  background: rgba(0, 0, 0, 0.6);
  z-index: 4;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  ${up("md")} {
    display: block;
    width: 100%;
    height: 100%;
  }

  &:hover {
    transform: scale(1.1);
  }
`

const LabelWrap = styled.div`
  transform: rotate(90deg);
  transform-origin: 0 0;
  position: absolute;
  display:none;
  line-height: 0px;

  ${up("md")} {
    display: table;
    left: -5%;
    top: 0;
  }
`

const Label = styled.p`
  font-family: ${TYPE.MONO_FONT};
  font-size: 1.1vh;
  color: ${props => props.color};
  line-height: 0px;
  opacity:.7;
  text-transform:uppercase;
`